import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import Meta from "../common/Meta";
import MDBox from "../../components/MDBox";
import CustomerPageLayout from "../Layout/CustomerPageLayout";
import {login, oneTimePassLogin, resetPass, subscribeNewsletter} from "../common/api/PortalCustomerApi";
import CustomerLoginForm from "../../CustomerLoginForm";
import {CompanyContext} from "../../lib/CompanyProvider";
import {useNavigate, useSearchParams} from "react-router-dom";
import CreateAccount from "../common/CreateAccount";
import {Grid, InputAdornment} from "@mui/material";
import MDInput from "../../components/MDInput";
import MDButton from "../../components/MDButton";
import MDTypography from "../../components/MDTypography";
import Divider from "@mui/material/Divider";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {UserContext} from "../../lib/UserProvider";
import {MenuContext} from "../../lib/MenuProvider";
import CustomerHeader from "../common/CustomerHeader";
import Footer from "../Footer";
import {Modal} from "react-bootstrap";

export default function CustomerLoginPage(props) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const [userContext, setUserContext] = useContext(UserContext);
  const [menuContext, setMenuContext] = useContext(MenuContext);

  const [showLogin, setShowLogin] = useState(props?.show);
  const [usernameEmail, setUsernameEmail] = useState('');
  const [email, setEmail] = useState('');
  const [passwd, setPasswd] = useState('');
  const [loggingIn, setLoggingIn] = useState(false);
  const [loginError, setLoginError] = useState(null);
  const [createAccount, setCreateAccount] = useState(props?.createAccount || false);

  const initialPass = searchParams.get('forgot');
  const initialOtp = searchParams.get('otp');

  const [showForgotPassword, setShowForgotPassword] = useState(initialPass === 'show');
  const [showForgotPasswordMessage, setShowForgotPasswordMessage] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [otp, setOtp] = useState('');

  useEffect(() => {
    if (props?.createAccount) {
      setCreateAccount(props?.createAccount);
    }
  }, [props?.createAccount]);


  useEffect(() => {
    setShowLogin(props?.show);
  }, [props?.show]);

  const [oneTimePassword, setOneTimePassword] = useState(initialOtp === 'show');
  const [otpMessage, setOtpMessage] = useState('');

  const toggleOneTimePassword = () => {
    let show = !oneTimePassword;
    setOneTimePassword(show);
    if (show) {
      searchParams.set('otp', 'show')
    } else {
      searchParams.delete('otp');
      searchParams.delete('forgot');
    }
    setSearchParams(searchParams);
  }


  const toggleShowForgotPassword = () => {
    setOneTimePassword(false);
    let show = !showForgotPassword;
    setShowForgotPassword(show);
    if (show) {
      searchParams.set('forgot', 'show')
    } else {
      searchParams.delete('forgot');
      searchParams.delete('otp');
    }
    setSearchParams(searchParams);
  }


  const toggleShowCreateAccount = () => {
    setCreateAccount(!createAccount);
  }

  const handleCreateAccount = () => {
    setShowLogin(false);
    props.handleClose();
  }

  const handleChange = (event) => {
    if (event.target.id === 'usernameEmail') {
      setUsernameEmail(event.target.value);
    }
    if (event.target.id === 'passwd') {
      setPasswd(event.target.value);
    }
    if (event.target.id === 'email') {
      setEmail(event.target.value);
    }
    if (event.target.id === 'otp') {
      setOtp(event.target.value);
    }
  };

  const forgotPassFn = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (oneTimePassword) {
      const auth = {
        email: email,
        code: otp
      };
      setLoginError(null);
      setLoggingIn(true);
      let result = await oneTimePassLogin(auth);

      if (result.error) {
        setLoginError(result.message);
      } else {
        setUserContext({...userContext, sessionUser: result, refreshIdentity: true});
        setMenuContext({...menuContext, refreshContext: true})
        window.location.reload();
      }

      setLoggingIn(false);

      return;
    }

    const auth = {
      email: email
    };

    setLoginError(null);
    setLoggingIn(true);
    let result = await resetPass(auth);

    if (result.error) {
      setLoginError(result.message);
    } else {
      setOneTimePassword(true);
      setShowForgotPasswordMessage(true);
      setOtpMessage('Please check your email for a One Time Password')
    }
    setLoggingIn(false);
  }

  const loginFn = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const auth = {
      email: usernameEmail,
      passwd: passwd
    };

    setLoginError(null);
    setLoggingIn(true);
    let result = await login(auth);
    if (result.error) {
      setLoginError(result.message);
    } else {
      setUserContext({...userContext, loginNag: false, sessionUser: result});
      setShowLogin(false);
      setUsernameEmail('');
      setPasswd('');
      if (props.handleLogin) {
        props.handleLogin(result);
      } else {
        let _u = {...userContext};
        setUserContext({..._u, refreshIdentity: true});
        setMenuContext({...menuContext, refreshContext: true})
        navigate('/cx/events');
      }
    }
    setLoggingIn(false);
  }

  return (
    <CustomerPageLayout>
      <CustomerHeader props={props}/>
      <Meta pageTitle={'Log in or Create Account'}/>

      <MDBox p={3}>
        <center>
          {!showForgotPassword && <h3>Log in or Create Account</h3>}
          {showForgotPassword && <h3>Reset Password</h3>}
        </center>
        {createAccount && <CreateAccount
          handleCancel={() => {
            setCreateAccount(false);
          }}
          handleSave={handleCreateAccount}/>}
        {!createAccount && <>
          {showForgotPassword && <form onSubmit={forgotPassFn}>
            <Grid container>
              <Grid item xs={12}>
                <MDBox>
                  <Grid container p={1}>
                    <Grid item xs={12} sm={12}>
                      <div className="form-group">
                        <MDInput type="email"
                                 variant="outlined"
                                 autoComplete="username-email"
                                 value={email || ''}
                                 onChange={handleChange}
                                 className="form-control" id="email" aria-describedby="emailHelp"
                                 label="Enter email"/>
                      </div>
                    </Grid>
                  </Grid>

                  {oneTimePassword && <>
                    <Grid container p={1}>
                      <Grid item xs={12} sm={12}>
                        <div className="form-group">
                          <MDInput type="text"
                                   variant="outlined"
                                   value={otp}
                                   onChange={handleChange}
                                   className="form-control" id="otp" aria-describedby="otpHelp"
                                   label="Enter One Time Password"/>
                        </div>
                      </Grid>
                      {otpMessage &&
                        <div className={'d-block w-100'}><p className={'mt-4 text-center d-block'}>{otpMessage}</p>
                        </div>}
                    </Grid>
                  </>
                  }

                  <Grid container spacing={3} mt={1}>
                    <Grid item xs={12} sm={12}>
                      <h5>

                        <center>
                          <MDButton type="submit" style={{
                            float: 'right'
                          }} color="info" disabled={loggingIn}>
                            {oneTimePassword && <>{loggingIn ? 'Signing In...' : 'Sign In'}</>}
                            {!oneTimePassword && <>{loggingIn ? 'Resetting Password...' : 'Reset Password'}</>}
                          </MDButton>
                          {props.handleCancel &&
                            <MDButton className={'pull-right mr-2'} color="info"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        props.handleCancel()
                                      }}>
                              Cancel
                            </MDButton>
                          }
                        </center>
                      </h5>

                      {loginError && <div className={'d-block'} style={{
                        clear: 'both',
                        width: '100%',
                        padding: '10px'
                      }}>
                        <p className={'text-center text-danger d-block'}>
                          The username and password you have entered do not match.<br/>
                          Please try again.
                        </p>
                      </div>
                      }

                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <MDTypography variant="p" fontWeight="light">
                        <Divider/>
                        {!oneTimePassword &&
                          <p className={'text-left'}><a className={'link-underline-info cursor-pointer'}
                                                        onClick={() => {
                                                          toggleOneTimePassword();
                                                        }}>Have a One Time Password?</a>
                          </p>}
                      </MDTypography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <MDTypography variant="p" fontWeight="light">
                        <Divider/>
                        <p className={'text-right'}><a className={'link-underline-info cursor-pointer'}
                                                       onClick={() => {
                                                         toggleShowForgotPassword();
                                                       }}>Back</a>
                        </p>
                      </MDTypography>
                    </Grid>
                  </Grid>
                </MDBox>
              </Grid>
            </Grid>
          </form>
          }

          {!showForgotPassword && <form onSubmit={loginFn}>
            <Grid container>
              <Grid item xs={12}>
                <MDBox>
                  <Grid container p={1}>
                    <Grid item xs={12} sm={12}>
                      <center>
                        <MDTypography
                          variant="h5"
                          fontWeight="light"
                        >Welcome Back!</MDTypography>
                      </center>
                      <div className="form-group">
                        <label htmlFor="usernameEmail">Email</label>
                        <MDInput type="email"
                                 variant="outlined"
                                 value={usernameEmail || ''}
                                 onChange={handleChange}
                                 className="form-control" id="usernameEmail"
                                 autoComplete="username-email"
                                 aria-describedby="usernameHelp"
                                 placeholder="Enter Email"/>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container p={1}>
                    <Grid item xs={12} sm={12}>
                      <div className="form-group">
                        <label htmlFor="passwd">Password</label>
                        <MDInput
                          autoComplete="current-passwd"
                          variant="outlined"
                          value={passwd}
                          InputProps={{
                            endAdornment: <InputAdornment style={{
                              cursor: 'pointer',
                              height: '50px',
                              padding: '15px 5px'
                            }} position="end" onClick={(e) => {
                              setShowPassword(!showPassword);
                            }}>
                              {showPassword ? <VisibilityOffIcon/> : <VisibilityIcon/>}
                            </InputAdornment>
                          }}
                          onChange={handleChange}
                          type={showPassword ? "text" : "password"}
                          className="form-control"
                          id="passwd"
                          placeholder="Enter Password"/>
                      </div>
                    </Grid>
                  </Grid>

                  <Grid container spacing={3} mt={1}>
                    <Grid item xs={12} sm={12}>
                      <center>
                        <MDButton type="submit" color="info" disabled={loggingIn}>
                          {loggingIn ? 'Logging in...' : 'Sign In'}
                        </MDButton>
                      </center>

                      {props.handleCancel &&
                        <MDTypography variant="h5" fontWeight="medium">
                          <MDButton className={'pull-right mr-2'} color="info"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      props.handleCancel()
                                    }}>
                            Cancel
                          </MDButton>
                        </MDTypography>
                      }

                      {loginError && <div className={'d-block'} style={{
                        clear: 'both',
                        width: '100%',
                        padding: '10px'
                      }}>
                        <p className={'text-center text-danger d-block'}>
                          The username and password you have entered do not match.<br/>
                          Please try again.
                        </p>
                      </div>
                      }

                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <MDTypography variant="p" fontWeight="light">
                        <Divider/>
                        <center>
                          <p className={'d-block'}>
                            Just getting started?
                          </p>
                          <p className={'d-block'}>
                            <MDButton
                              color="primary"
                              onClick={(e) => {
                                toggleShowCreateAccount();
                              }}>Create Account</MDButton>
                          </p>

                          <p>
                            <small>
                              <b style={{
                                fontWeight: '500'
                              }}>Signed a waiver in person?</b><br/>
                              An account was already created for you. <br/>
                              Click <a className={'link-underline-info cursor-pointer'} onClick={() => {
                              toggleShowForgotPassword();
                            }}>Forgot Password</a> to set your password and access your account.
                            </small>
                          </p>
                        </center>


                        {showForgotPasswordMessage &&
                          <center>
                            <p>
                              Password reset instructions have been emailed to you
                            </p>
                          </center>
                        }

                      </MDTypography>

                    </Grid>
                  </Grid>
                </MDBox>
              </Grid>
            </Grid>
          </form>}
        </>}


        {createAccount && <Modal.Footer style={{
          background: '#EFEFEF3F',
          justifyContent: 'center'
        }}>
          <center>
            <p>
              Already have an account?
              <br/>
              <a className={'link-underline-info cursor-pointer'} onClick={() => {
                setCreateAccount(false);
              }}>Sign In</a>
            </p>
          </center>
        </Modal.Footer>
        }

        {!showForgotPassword && !createAccount && <MDBox style={{
          justifyContent: 'center'
        }}>
          <div>
            <center>
              <p>
                <a className={'link-underline-info cursor-pointer'} onClick={() => {
                  toggleShowForgotPassword();
                }}>Forgot Password</a>
              </p></center>
          </div>
        </MDBox>}

      </MDBox>
      <Footer/>
    </CustomerPageLayout>
  );
}